import React from "react"
import { ConfigProvider, Pagination } from "antd"
import { translations } from "../../utils/Translation/staticTranslation"
import "./PlansPricing.css"

const LRI = "\u2066"
const PDI = "\u2069"

function formatPaginationTotal(template, range, totalCount, isRtl) {
  const start = String(range[0])
  const end = String(range[1])
  const total = String(totalCount)

  if (isRtl) {
    const rangeText = `${LRI}${start}-${end}${PDI}`
    const totalText = `${LRI}${total}${PDI}`
    return template
      .replace("{start}-{end}", rangeText)
      .replace("{start}", rangeText)
      .replace("{end}", end)
      .replace("{total}", totalText)
  }

  return template
    .replace("{start}", start)
    .replace("{end}", end)
    .replace("{total}", total)
}

const PlansPricingPagination = ({
  current,
  pageSize,
  total,
  onChange,
  className = "",
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const isRtl = lang === "ar"
  const t = translations[lang]?.plansPricingPage

  if (!total || total <= 0) return null

  return (
    <div className={`plans-pricing-pagination-wrap ${className}`.trim()}>
      <ConfigProvider direction={isRtl ? "rtl" : "ltr"}>
        <Pagination
          current={current}
          pageSize={pageSize}
          total={total}
          showSizeChanger={false}
          showTotal={(totalCount, range) => {
            const template =
              t?.pagination?.show_total || "{start}-{end} of {total}"
            return formatPaginationTotal(template, range, totalCount, isRtl)
          }}
          onChange={onChange}
        />
      </ConfigProvider>
    </div>
  )
}

export default PlansPricingPagination
